// src/store/modules/auth.js
export default {
  namespaced: true,
  state: {
    accessToken: null,
    refreshToken: null,
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    setRefreshToken(state, token) {
      state.refreshToken = token;
    },
    clearTokens(state) {
      state.accessToken = null;
      state.refreshToken = null;
    },
  },
  actions: {
    async login({ commit }, { email, password }) {
      // Login logic that saves tokens on successful login
    },
    async logout({ commit }) {
      commit('clearTokens');
      // Handle any logout logic (e.g., API call to invalidate tokens)
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.accessToken,
  },
};
